var NewVehicleCtrl = function ($scope, previousState, customerModelService, $log, SettingsConstants, $state) {

};
NewVehicleCtrl.$inject = ['$scope', 'previousState', 'customerModelService', '$log', 'SettingsConstants', '$state'];

module.exports = NewVehicleCtrl;